<ng-template #template>
  <div class="row container">
    <div class="col-md-6 mt-2">
      <h5 class="modal-title pull-left">
        <b> {{ 'COMMON.USERS_LIST' | translate }}</b>
      </h5>
    </div>
    <div class="col-md-6 d-flex flex-row-reverse mt-4">
      <button
        mat-flat-button
        color="primary"
        class="flat-info-btn btn-text-size mt-3"
        (click)="onClickUserSelect()"
      >
        {{ 'COMMON.APPLY_FILTER' | translate }}<mat-icon>add</mat-icon>
      </button>
      &nbsp;&nbsp;&nbsp;
      <button
        mat-stroked-button
        color="primary"
        class="btn-border outline-info-btn btn-text-size mt-3"
        (click)="handleCancel()"
      >
        {{ 'COMMON.CANCEL' | translate }}<mat-icon>cancel</mat-icon>
      </button>
      &nbsp;&nbsp;&nbsp;
    </div>
  </div>
  <div class="modal-body">
    <app-loader *ngIf="isLoading"></app-loader>
    <div class="row">
      <div class="col-md-12 table-container">
        <table mat-table [dataSource]="dataSource" class="fleet-table">
          <ng-container matColumnDef="Checkbox">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                (change)="$event ? toggleAllRows() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
              >
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)"
              >
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="UserName">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'COMMON.FULL_NAME' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.fullName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="Email">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'COMMON.EMAIL' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.email }}
            </td>
          </ng-container>
          <ng-container matColumnDef="Team">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'ADMINISTRATION.TEAM' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.team }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <p *ngIf="!isUsersExists" class="text-center mt-2">
          {{ 'COMMON.THERE_ARE_NO_USERS_FOR_THE_SELECTED_TEAM' | translate }}
        </p>
      </div>
    </div>
  </div>
</ng-template>
